// Fachada do domínio MKT — métodos da instância (ver core.ts).
import { mktService } from './core';

export const notifyMktConversion = mktService.notifyMktConversion;
export const listLeadMktEntries  = mktService.listLeadMktEntries;

// Predicado do erro de permissão da RPC get_lead_mkt_entries (usado na UI).
export { isMktAccessDenied } from '@modules/mkt';

export type { MktAction, NotifyMktConversionOpts, MktLeadEntry } from '@modules/mkt';
